import { IEventEnrollment } from '../../../store/player/events/store';
export const isEventEnrollment = (item: any): item is IEventEnrollment =>
  (item as IEventEnrollment).status !== undefined;
